import { FormInstance } from 'antd';
import styled from 'styled-components';
import { FormValues } from '../PlaylistForm';
import { InputSearch } from 'basic-ui-lib';
import useGetManageLibrary from 'modules/media/services/hooks/useGetManageLibrary';
import { IMediaItem, MediaType } from 'modules/media/interfaces/api';
import { useGetMedia } from 'modules/channel/services/hooks/useGetMedia';
import { Breadcrumb } from '../Breadcrumb';
import { useEffect, useState } from 'react';
import { IContentItem } from 'modules/playlist/interfaces/api';
import DraggableMedia from './DraggableMedia';
import getVideoDuration from 'utils/getVideoDuration';

interface MediaContentProps {
  form?: FormInstance<FormValues>;
}

const MediaContent = ({ form }: MediaContentProps) => {
  const [data, mutate] = useGetManageLibrary();
  const { items, pathStack, openFolder, onBack } = useGetMedia(data, mutate);
  const [searchValue, setSearchValue] = useState('');
  const [filteredItems, setFilteredItems] = useState<IMediaItem[]>(items);

  const onPickMedia = async (item: IMediaItem) => {
    const oldItems = form?.getFieldValue('contentItems') || [];

    if (oldItems.find((i: IContentItem) => i.id === item.id)) {
      return;
    }
    const nextItem: IContentItem = {
      type: item.type,
      url: item.url || '',
      duration: await getVideoDuration(item.url),
      indexPlay: oldItems.length + 1,
      name: item.name,
      id: item.id,
    };

    form?.setFieldsValue({
      contentItems: [...oldItems, nextItem],
    });
  };

  const onClickMedia = (item: IMediaItem) => {
    if (item.type === MediaType.FOLDER) {
      openFolder(item);
    } else {
      onPickMedia(item);
    }
  };

  useEffect(() => {
    if (searchValue.trim() === '') {
      setFilteredItems(items);
    } else {
      const lowerSearch = searchValue.toLowerCase();
      setFilteredItems(items.filter((item) => item.name.toLowerCase().includes(lowerSearch)));
    }
  }, [searchValue, items]);
      
  return (
    <Container>
      <InputSearch placeholder='Search image/video' onChange={(value) => setSearchValue(value)} />
      <Breadcrumb path={pathStack} onBack={onBack} items={items} />
      <Content>
        {filteredItems.map((item) => (
          <DraggableMedia
            key={item.id}
            item={item}
            onClick={() => onClickMedia(item)}
          />
        ))}
      </Content>
    </Container>
  );
};

export default MediaContent;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
`;
